import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import moment from 'moment';
import sniffer from 'sniffer';
import getEnvironment from 'lib/env';
import FooterMenu from './Menu';
import project from '../../../package.json';

var Footer = /*#__PURE__*/function (_Component) {
  _inherits(Footer, _Component);

  var _super = _createSuper(Footer);

  function Footer() {
    _classCallCheck(this, Footer);

    return _super.apply(this, arguments);
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, sniffer.isDesktop || sniffer.isTablet ? /*#__PURE__*/React.createElement("div", {
        className: "site-footer footer"
      }, /*#__PURE__*/React.createElement("div", {
        className: "footer-content"
      }, "Haldor - ", moment().format('YYYY'), getEnvironment().type == 'production' || getEnvironment().type == 'staging' ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '0.35em'
        }
      }, "Release ", project.version) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '0.35rem'
        }
      }, "Session ID: ", localStorage.getItem('hsid')), getEnvironment().type == 'dev' || getEnvironment().type == 'test' ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '0.35em'
        }
      }, "Release ", project.version, " Development Preview") : null)) : null, /*#__PURE__*/React.createElement(FooterMenu, null));
    }
  }]);

  return Footer;
}(Component);

export default Footer;